document.addEventListener('DOMContentLoaded', () => {
  const texts = document.querySelectorAll('.s-caro-circle__text');
  const dots = document.querySelectorAll('.dot-navigation__item');

  if (texts.length === 0 || dots.length === 0) return;

  let currentSlideIndex = 0;
  let timerId;

  function updateSlide() {
    dots.forEach((dot, index) => {
      if (index === currentSlideIndex) {
        dot.classList.add('dot-navigation__item--current');

        if (texts[index]) {
          texts[index].classList.add('current');
        }
      } else {
        dot.classList.remove('dot-navigation__item--current');

        if (texts[index]) {
          texts[index].classList.remove('current');
        }
      }
    });
  }

  function nextSlide() {
    currentSlideIndex = currentSlideIndex || 0;

    if (currentSlideIndex !== dots.length - 1) {
      currentSlideIndex += 1;
    } else {
      currentSlideIndex = 0;
    }

    updateSlide();
    timerId = setTimeout(nextSlide, 11000);
  }

  function onSlideClick(index) {
    currentSlideIndex = index;
    clearTimeout(timerId);
    updateSlide();
    timerId = setTimeout(nextSlide, 11000);
  }

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      onSlideClick(index);
    });
  });

  // Initialize the slider
  updateSlide();
  timerId = setTimeout(nextSlide, 11000);
});
